import { alpha, Autocomplete, Box, Link, styled, Typography } from '@mui/material';
import theme from 'theme';

const Container = styled(Box)({
  marginTop: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  height: '100%',
  justifyContent: 'space-between',
});

const HeaderRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '1rem',
  width: '100%',
});

const InfoColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
});

const Row = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1.5),
  alignItems: 'center',
});

const DealNameContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
});

const StyledLinkSpan = styled('span')({
  fontWeight: '700',
  fontSize: '1.125rem',
  cursor: 'pointer',
  color: theme.palette.white,
  textDecoration: 'underline',
  textDecorationColor: theme.palette.white,
  textDecorationThickness: '1px',
  textUnderlineOffset: '2px',
  textDecorationSkipInk: 'none',
  textDecorationSkip: 'none',
});

const EngagementLetterLink = styled(Link)({
  color: theme.palette.black,
  textDecorationColor: theme.palette.black,
});

const LabelRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

const Field = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '45%',
});

const Label = styled(Typography)(() => ({
  fontWeight: '400',
  fontSize: '0.95rem',
}));

const Value = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '0.95rem',
});

const StyledBadge = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.text.primary, 0.1),
  color: theme.palette.text.primary,
  fontSize: '0.85rem',
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(0.5, 1.5),
  cursor: 'pointer',
  width: 'fit-content',
  whiteSpace: 'nowrap',
}));

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  width: '10rem',
  '& .MuiOutlinedInput-root': {
    minHeight: 32,
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    paddingLeft: theme.spacing(1),
    paddingRight: `${theme.spacing(4)} !important`,
    fontSize: '0.75rem',
    backgroundColor: '#9CE8CD',
    borderRadius: theme.spacing(0.75),
    color: '#046140'
  },
  '& .MuiOutlinedInput-input': {
    padding: '6px 4px !important',
    fontSize: '0.75rem',
    height: 'auto',
    lineHeight: 1.25,
  },
  '& .MuiAutocomplete-endAdornment': {
    right: 6,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.125rem',
  },
}));

export {
  Container,
  HeaderRow,
  DealNameContainer,
  InfoColumn,
  StyledLinkSpan,
  EngagementLetterLink,
  LabelRow,
  Label,
  Value,
  StyledBadge,
  Field,
  Row,
  StyledAutocomplete,
};
